import { render, staticRenderFns } from "./AutosEmbargosIpaamPol.vue?vue&type=template&id=ee4d0376&lang=pug"
import script from "./AutosEmbargosIpaamPol.vue?vue&type=script&lang=js"
export * from "./AutosEmbargosIpaamPol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports